import { IconButton, Link, makeStyles, Paper, SvgIcon, Theme } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import LinkOffIcon from '@material-ui/icons/LinkOff';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import ExpandIcon from '@material-ui/icons/SettingsOverscan';
import React from 'react';

import { ReactComponent as PinSvg } from '../../../../assets/pin.svg';
import { LinkPreviewMetadataFragment } from '../../../../graphql/gen/types';
import { colorPalette, spacings, TextSizesEnum } from '../../../../theme';
import { LinkPreviewBox } from '../../../logged_in/shared/LinkPreviewBox';
import { PlexTypographyEllipsed } from '../../primitives/PlexTypographyEllipsed';

type Props = {
  url: string;
  preview:
    | {
        state: 'loading';
      }
    | {
        state: 'done';
        linkMetadata: LinkPreviewMetadataFragment;
      };
  isPrimaryLink: boolean;
  onSetAsPrimaryLink: () => void;
  onEdit: () => void;
  expandDisabled?: boolean;
  onExpand: () => void;
  onUnlink: () => void;
};
export const LinkPreview = ({
  url,
  preview,
  isPrimaryLink,
  onSetAsPrimaryLink,
  onEdit,
  expandDisabled,
  onExpand,
  onUnlink,
}: Props): React.ReactElement => {
  const classes = useStyles();

  // TODO: add detailed preview with loading state

  return (
    <Paper className={classes.root}>
      <div className={classes.header}>
        <Link className={classes.linkTitleContainer} href={url} tabIndex={-1} target="_blank" rel="noopener noreferrer">
          <PlexTypographyEllipsed className={classes.linkTitle} text={url} tooltip={url} size={TextSizesEnum.Normal} />
          <OpenInNewIcon />
        </Link>

        <div className={classes.linkActions}>
          <IconButton className={classes.linkAction} onClick={onSetAsPrimaryLink} size="small" tabIndex={1}>
            <SvgIcon>
              <PinSvg className={isPrimaryLink ? classes.iconColorEnabled : classes.iconColorDefault} />
            </SvgIcon>
          </IconButton>

          <IconButton className={classes.linkAction} onClick={onEdit} size="small" tabIndex={1}>
            <EditIcon />
          </IconButton>

          <IconButton
            disabled={expandDisabled}
            className={classes.linkAction}
            onClick={onExpand}
            size="small"
            tabIndex={1}
          >
            <ExpandIcon />
          </IconButton>

          <IconButton className={classes.linkAction} onClick={onUnlink} size="small" tabIndex={1}>
            <LinkOffIcon />
          </IconButton>
        </div>
      </div>
      <div className={classes.preview}>
        {preview?.state === 'done' && <LinkPreviewBox openPlexLinksInNewTab linkMetadata={preview.linkMetadata} />}
      </div>
    </Paper>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: 500,
    color: theme.palette.common.black,
    padding: spacings.normal,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  linkTitleContainer: {
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
  },
  linkTitle: {
    color: colorPalette.dark._900,
    maxWidth: 200,
  },
  linkActions: {
    flexShrink: 0,
  },
  linkAction: {
    background: '#FFFFFF',
    border: '1px solid #E5E5E5',
    borderRadius: 360,

    margin: `0 ${spacings.xsmall}px`,
  },
  preview: {
    display: 'flex',
    justifyContent: 'center',
  },
  iconColorDefault: {
    fill: 'currentColor',
  },
  iconColorEnabled: {
    fill: colorPalette.primaryColorBlue._500,
  },
}));
